/* eslint-disable import/order */
import { FormProps } from '~/common/types/form'
import validatorComposer from '~/form/libs/validatorComposer'
import { FORM_TYPE_IDS, FormTypeId } from '~/common/constants/formTypes'

import { validators } from '~/form/configs'

type Props = {
  formTypeId: FormTypeId
  values: FormProps
}

type Validators = {
  [key in FormTypeId]?: {
    validate: (values: FormProps) => any
  }
}

const createValidators = () => {
  const validatorRules: Validators = {}

  FORM_TYPE_IDS.forEach((formTypeId) => {
    if (validators[formTypeId]) {
      validatorRules[formTypeId] = {
        validate: (values: FormProps) =>
          validatorComposer({
            validators: validators[formTypeId],
            values,
          }),
      }
    }
  })

  return validatorRules
}

const validates: Validators = createValidators()

const createFormValidate = ({ values, formTypeId }: Props) => {
  return validates[formTypeId]?.validate(values)
}

export default createFormValidate
